import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import cx from "classnames";

// Styles
import withStyles from "isomorphic-style-loader/withStyles";
import bt from "../../../components/commonStyle.css";
import s from "../ViewMessage.css";

// Components
import Loader from "../../Loader";

// Actions
import { makePaymentForCancel } from "../../../actions/booking/makePaymentForCancel";

// Helpers
import messages from "../../../locale/messages";

const PaymentButton = ({
    reservationData,
    makePaymentForCancel,
    disabled = false,
    className,
    threadId,
}) => {
    const [paymentLoading, setPaymentLoading] = useState(false);

    const handlePayment = async () => {
        if (!reservationData) {
            return;
        }

        setPaymentLoading(true);

        try {
            // Use exact same logic as Payment submit.js
            const amount = reservationData.total; // + reservationData.guestServiceFee;

            await makePaymentForCancel(
                reservationData.id,
                amount,
                reservationData.currency,
                reservationData.currency, // paymentCurrency (same as currency)
                reservationData.listTitle,
            );
        } catch (error) {
            console.error("Payment error:", error);
        } finally {
            setPaymentLoading(false);
        }
    };

    return (
        <Loader
            type="button"
            buttonType="submit"
            className={cx(
                bt.btnPrimary,
                bt.btnlarge,
                "arButtonLoader",
                s.loaderFlex,
                className,
            )}
            disabled={disabled || paymentLoading}
            show={paymentLoading}
            label={<FormattedMessage {...messages.proceedToPayment} />}
            handleClick={handlePayment}
        />
    );
};

PaymentButton.propTypes = {
    reservationData: PropTypes.object.isRequired,
    makePaymentForCancel: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    threadId: PropTypes.number,
};

const mapDispatch = {
    makePaymentForCancel,
};

export default connect(null, mapDispatch)(withStyles(bt, s)(PaymentButton));
